<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-table`]" width="1em" height="1em" v-bind="$attrs"><path d="M8.67105 7.74219L8.67105 20.3614M15.3289 7.74219L15.3289 20.3614M2.77145 14.0547H21.2285" stroke="#00BBD8" stroke-width="1.66"/><rect x="2.771" y="3.641" width="18.457" height="16.536" rx="3" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/><path d="M2.77145 8.39062H21.2285" stroke="#165DFF" stroke-width="1.66"/></svg>
</template>
<script>

export default {
  name: 'IconColorTable',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
